import { Button, Flex, Text, VStack } from "@chakra-ui/react";
import { RiAddFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import { openCreatePaymentModel } from "../../../modules/admin-modules/models/Actions";

const SearchBar = ({ setAdd, setSearchTerm }) => {
  const dispatch = useDispatch();
  const payments = useSelector((state) => state.superadminPayment.count);

  return (
    <VStack w="100%" my="30px">
      <Flex alignItems="center" w="100%" justifyContent="space-between">
        <Text fontSize="24px" fontWeight="600" color="main_1">
          الدفع{" "}
        </Text>

        <Flex alignItems="center">
          <Button
            borderRadius="16px"
            mx="7px"
            leftIcon={<RiAddFill />}
            color="white"
            bg="main_1"
            _focus={{ outline: "none" }}
            onClick={() => {
              setAdd(true);
              dispatch(openCreatePaymentModel());
            }}
          >
            إضافة الدفع
          </Button>
          <LogoutMenu />
        </Flex>
      </Flex>
    </VStack>
  );
};

export default SearchBar;
